<template>
<div>
  <div style="height: 40px;margin: 10px 40px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0">
    <basic-staff :basicObj="serviceperson" @changeEndBasic="changeInfo"></basic-staff>
  </div>
  <div v-if="indexActive === 1">
    <details-info :infoObj="serviceperson" @changeEndInfo="changeInfo"></details-info>
  </div>
  <div v-if="indexActive === 2">
    <service-person-file :infoRow="serviceperson"></service-person-file>
  </div>
</div>
</template>

<script>
import basicStaff from './basicStaff'
import detailsInfo from './detailsInfo'
import servicePersonFile from './servicePersonFile.vue'
export default {
  name: 'addStaff',
  components: {basicStaff, detailsInfo, servicePersonFile},
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    staffRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基本信息'},
        {index: 1, name: '信息详情'},
        {index: 2, name: '资质证书'}
      ],
      indexActive: 0,
      serviceperson: {
        treeOrg: [],
        entityArr: [],
        isAdd: true,
        isBtn: false, // 是否接口按钮之后再次点击
        servicepersonRow: '',
        formServicePerson: {
          id: 0,
          e_id: 0,
          orgid: '', // 组织id
          org_person_id: 0, // 客服坐席人员表ID，新增为0
          // is_del: 0,
          service_personnel_id: '',
          service_personnel_name: '',
          service_personnel_identity_document_type_code: '',
          service_personnel_identity_card_number: '',
          service_personnel_gender: '',
          service_personnel_ethnic: '',
          service_personnel_birth_date: '',
          service_personnel_photo: null,
          service_personnel_contact_number: '',
          service_personnel_contact_address: '',
          service_personnel_postal_code: '',
          service_personnel_household_address: '',
          service_personnel_household_administrative_division_code: '',
          service_personnel_household_postal_code: '',
          service_personnel_cultural_degree_code: '',
          service_personnel_political_status_code: '',
          service_personnel_marital_status_code: '',
          service_personnel_email_address: '',
          affiliated_unit_name: '',
          affiliated_unit_code: '',
          service_personnel_employment_method_code: '',
          service_personnel_department_name: '',
          service_personnel_job_nature_code: '',
          service_personnel_job_code: '',
          service_personnel_job_title_code: '',
          social_security_card_ownership_sign: false,
          entry_permit_ownership_sign: false,
          entry_date: '',
          start_work_date: '',
          service_personnel_service_status_code: '',
          service_personnel_service_hour_attribute_code: '',
          current_township_number: '',
          affiliated_service_station: '',
          available_home_service_time_description: '',
          available_community_committee_code: '',
          available_community_committee_name: '',
          affiliated_community_committee_code: '',
          affiliated_community_committee_name: '',
          professional_qualification_certificate_name: '',
          professional_qualification_certificate_type_code: '',
          professional_qualification_certificate_level: '',
          professional_qualification_certificate_acquisition_date: '',
          professional_qualification_certificate_number: '',
          professional_qualification_certificate_issuing_organization_name: '',
          professional_qualification_certificate_validity_period: '',
          service_technology_level_code: '',
          health_certificate_category_code: '',
          health_certificate_number: '',
          health_certificate_acquisition_date: '',
          health_certificate_issuing_organization_name: '',
          service_personnel_medical_examination_date: '',
          service_personnel_medical_examination_result_description: '',
          service_personnel_health_status_description: '',
          service_personnel_service_star_level: '',
          training_records: '',
          in_service_training_hours_total: 0,
          job_transfer_records: '',
          assessment_year_month: '',
          completed_service_orders_number: 0,
          number_of_people_served: 0,
          number_of_service_people: 0,
          service_completion_rate: 0,
          number_of_service_complaints: 0,
          number_of_people_complained_about_services: 0,
          service_complaint_rate: 0,
          performance_evaluation_level: '',
          performance_evaluation_comments: '',
          performance_evaluation_date: '',
          performance_evaluation_department: '',
          service_star_rating_evaluation: '',
          service_personnel_departure_date: '',
          service_personnel_reason_for_leaving: '',
          auth_code: ''
        }
      }
    }
  },
  created () {
    this.serviceperson.formServicePerson.orgid = this.$store.state.user.orgid
    this.serviceperson.formServicePerson.e_id = this.$store.state.user.LoginResp.entity_id
    if (!this.staffRow.isAdd) {
      this.getFormData()
    }
    this.serviceperson.treeOrg = this.staffRow.treeOrg
    this.serviceperson.entityArr = this.staffRow.entityArr
    this.serviceperson.isAdd = this.staffRow.isAdd
    this.serviceperson.servicepersonRow = this.staffRow.servicepersonRow
  },
  methods: {
    getFormData () {
      this.serviceperson.formServicePerson = {
        id: this.staffRow.row.id,
        e_id: this.staffRow.row.e_id,
        orgid: this.staffRow.row.orgid,
        org_person_id: this.staffRow.row.org_person_id,
        // is_del: this.staffRow.row.is_del,
        service_personnel_id: this.staffRow.row.service_personnel_id,
        service_personnel_name: this.staffRow.row.service_personnel_name,
        service_personnel_identity_document_type_code: this.staffRow.row.service_personnel_identity_document_type_code,
        service_personnel_identity_card_number: this.staffRow.row.service_personnel_identity_card_number,
        service_personnel_gender: this.staffRow.row.service_personnel_gender,
        service_personnel_ethnic: this.staffRow.row.service_personnel_ethnic,
        service_personnel_birth_date: this.staffRow.row.service_personnel_birth_date,
        service_personnel_photo: this.staffRow.row.service_personnel_photo,
        service_personnel_contact_number: this.staffRow.row.service_personnel_contact_number,
        service_personnel_contact_address: this.staffRow.row.service_personnel_contact_address,
        service_personnel_postal_code: this.staffRow.row.service_personnel_postal_code,
        service_personnel_household_address: this.staffRow.row.service_personnel_household_address,
        service_personnel_household_administrative_division_code: this.staffRow.row.service_personnel_household_administrative_division_code,
        service_personnel_household_postal_code: this.staffRow.row.service_personnel_household_postal_code,
        service_personnel_cultural_degree_code: this.staffRow.row.service_personnel_cultural_degree_code,
        service_personnel_political_status_code: this.staffRow.row.service_personnel_political_status_code,
        service_personnel_marital_status_code: this.staffRow.row.service_personnel_marital_status_code,
        service_personnel_email_address: this.staffRow.row.service_personnel_email_address,
        affiliated_unit_name: this.staffRow.row.affiliated_unit_name,
        affiliated_unit_code: this.staffRow.row.affiliated_unit_code,
        service_personnel_employment_method_code: this.staffRow.row.service_personnel_employment_method_code,
        service_personnel_department_name: this.staffRow.row.service_personnel_department_name,
        service_personnel_job_nature_code: this.staffRow.row.service_personnel_job_nature_code,
        service_personnel_job_code: this.staffRow.row.service_personnel_job_code,
        service_personnel_job_title_code: this.staffRow.row.service_personnel_job_title_code,
        social_security_card_ownership_sign: this.staffRow.row.social_security_card_ownership_sign,
        entry_permit_ownership_sign: this.staffRow.row.entry_permit_ownership_sign,
        entry_date: this.staffRow.row.entry_date,
        start_work_date: this.staffRow.row.start_work_date,
        service_personnel_service_status_code: this.staffRow.row.service_personnel_service_status_code,
        service_personnel_service_hour_attribute_code: this.staffRow.row.service_personnel_service_hour_attribute_code,
        current_township_number: this.staffRow.row.current_township_number,
        affiliated_service_station: this.staffRow.row.affiliated_service_station,
        available_home_service_time_description: this.staffRow.row.available_home_service_time_description,
        available_community_committee_code: this.staffRow.row.available_community_committee_code,
        available_community_committee_name: this.staffRow.row.available_community_committee_name,
        affiliated_community_committee_code: this.staffRow.row.affiliated_community_committee_code,
        affiliated_community_committee_name: this.staffRow.row.affiliated_community_committee_name,
        professional_qualification_certificate_name: this.staffRow.row.professional_qualification_certificate_name,
        professional_qualification_certificate_type_code: this.staffRow.row.professional_qualification_certificate_type_code,
        professional_qualification_certificate_level: this.staffRow.row.professional_qualification_certificate_level,
        professional_qualification_certificate_acquisition_date: this.staffRow.row.professional_qualification_certificate_acquisition_date,
        professional_qualification_certificate_number: this.staffRow.row.professional_qualification_certificate_number,
        professional_qualification_certificate_issuing_organization_name: this.staffRow.row.professional_qualification_certificate_issuing_organization_name,
        professional_qualification_certificate_validity_period: this.staffRow.row.professional_qualification_certificate_validity_period,
        service_technology_level_code: this.staffRow.row.service_technology_level_code,
        health_certificate_category_code: this.staffRow.row.health_certificate_category_code,
        health_certificate_number: this.staffRow.row.health_certificate_number,
        health_certificate_acquisition_date: this.staffRow.row.health_certificate_acquisition_date,
        health_certificate_issuing_organization_name: this.staffRow.row.health_certificate_issuing_organization_name,
        service_personnel_medical_examination_date: this.staffRow.row.service_personnel_medical_examination_date,
        service_personnel_medical_examination_result_description: this.staffRow.row.service_personnel_medical_examination_result_description,
        service_personnel_health_status_description: this.staffRow.row.service_personnel_health_status_description,
        service_personnel_service_star_level: this.staffRow.row.service_personnel_service_star_level,
        training_records: this.staffRow.row.training_records,
        in_service_training_hours_total: this.staffRow.row.in_service_training_hours_total,
        job_transfer_records: this.staffRow.row.job_transfer_records,
        assessment_year_month: this.staffRow.row.assessment_year_month,
        completed_service_orders_number: this.staffRow.row.completed_service_orders_number,
        number_of_people_served: this.staffRow.row.number_of_people_served,
        number_of_service_people: this.staffRow.row.number_of_service_people,
        service_completion_rate: this.staffRow.row.service_completion_rate,
        number_of_service_complaints: this.staffRow.row.number_of_service_complaints,
        number_of_people_complained_about_services: this.staffRow.row.number_of_people_complained_about_services,
        service_complaint_rate: this.staffRow.row.service_complaint_rate,
        performance_evaluation_level: this.staffRow.row.performance_evaluation_level,
        performance_evaluation_comments: this.staffRow.row.performance_evaluation_comments,
        performance_evaluation_date: this.staffRow.row.performance_evaluation_date,
        performance_evaluation_department: this.staffRow.row.performance_evaluation_department,
        service_star_rating_evaluation: this.staffRow.row.service_star_rating_evaluation,
        service_personnel_departure_date: this.staffRow.row.service_personnel_departure_date,
        service_personnel_reason_for_leaving: this.staffRow.row.service_personnel_reason_for_leaving,
        auth_code: this.staffRow.row.auth_code
      }
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    changeInfo (obj) {
      if (obj.type === 'close') {
        if (this.serviceperson.isBtn) {
          this.$emit('updateTable')
        }
        this.$emit('change', false)
      } else if (obj.type === 'isBtnBasic') { // 基本信息 点击按钮
        this.serviceperson.isAdd = false
        this.serviceperson.isBtn = true
        this.serviceperson.formServicePerson.id = obj.form.id
        this.serviceperson.formServicePerson.service_personnel_name = obj.form.service_personnel_name
        this.serviceperson.formServicePerson.service_personnel_gender = obj.form.service_personnel_gender
        this.serviceperson.formServicePerson.service_personnel_photo = obj.form.service_personnel_photo
        this.serviceperson.formServicePerson.service_personnel_contact_number = obj.form.service_personnel_contact_number
        this.serviceperson.formServicePerson.service_personnel_service_status_code = obj.form.service_personnel_service_status_code
        this.serviceperson.formServicePerson.e_id = obj.form.e_id
        // this.serviceperson.formServicePerson.extra_info.service_phone1 = obj.form.extra_info.service_phone1
        // this.serviceperson.formServicePerson.extra_info.service_phone2 = obj.form.extra_info.service_phone2
        this.$emit('updateTable')
        this.$emit('change', false)
      } else if (obj.type === 'isBtnInfo') { // 信息详情 点击按钮
        this.serviceperson.isAdd = false
        this.serviceperson.isBtn = true
        this.serviceperson.formServicePerson.id = obj.form.id
        this.serviceperson.formServicePerson.service_personnel_identity_card_number = obj.form.service_personnel_identity_card_number
        this.serviceperson.formServicePerson.service_personnel_ethnic = obj.form.service_personnel_ethnic
        this.serviceperson.formServicePerson.service_personnel_birth_date = obj.form.service_personnel_birth_date
        this.serviceperson.formServicePerson.service_personnel_contact_address = obj.form.service_personnel_contact_address
        this.serviceperson.formServicePerson.service_personnel_cultural_degree_code = obj.form.service_personnel_cultural_degree_code
        this.serviceperson.formServicePerson.service_personnel_political_status_code = obj.form.service_personnel_political_status_code
        this.serviceperson.formServicePerson.entry_date = obj.form.entry_date
        this.serviceperson.formServicePerson.service_personnel_departure_date = obj.form.service_personnel_departure_date
        this.serviceperson.formServicePerson.service_personnel_household_address = obj.form.service_personnel_household_address
        this.$emit('updateTable')
        this.$emit('change', false)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addStaff.vue